module.exports = __webpack_public_path__ + "img/boccato.037e6238.jpg";